import { ActionKey, SessionAction } from "../../../actions/session";
import {
  ActionKey as UserActionKey,
  ViewerAction as UserAction,
} from "../../../actions/viewer";
import { UserState } from "../../../types";

// TODO(cochamberlain): update selectors to do what the viewer props did if user null (anonymous).
export const user = (
  state: UserState | null = null,
  action: SessionAction | UserAction
): UserState | null => {
  switch (action.type) {
    case ActionKey.SET_SESSION_STATE:
      return action.payload.session.user;
    // TODO(cochamberlain): Deprecate the duplicate user (viewer) state.
    case UserActionKey.SET_USER:
      return action.payload.user;
    default:
      return state;
  }
};
